import { createVanIconComponent } from "./van"

const GoodJob = createVanIconComponent("good-job")
export default GoodJob
